import ApiGet from "api/ApiGet";
import { setDataLoading } from "redux/global/globalActions";
import { responseResult } from "utils/ResponseStatus";
import { RESETPENGADAAN, SETPENGADAAN, RESETFILEBYID, SETFILEBYID } from "./pengadaanTypes";

export const setPengadaan = (payload) => {
    return {
        type: SETPENGADAAN,
        payload,
    };
};
export const resetPengadaan = () => {
    return {
        type: RESETPENGADAAN,
    };
};

export const setFileById = (payload) => {
    return {
        type : SETFILEBYID,
        payload
    }
}

export const resetFileById = (payload) => {
    return {
        type : RESETFILEBYID,
        payload
    }
}
export const getPengadaan = (params) => async (dispatch) => {
    dispatch(setDataLoading(true));
    return ApiGet.actions.Pengadaan(params)
        .then(res => {
            // console.log("Res Action Pengadaan", res)
            if (responseResult(res)) {
                dispatch(setPengadaan({
                    data: responseResult(res)
                }));
            }
            dispatch(setDataLoading(false));
        })
        .catch(err => {
            dispatch(resetPengadaan())
            dispatch(setDataLoading(false));
        })
};

export const getFileById = (paramsFile) => async (dispatch) => {
    dispatch(setDataLoading(true))
    // console.log("paramsssSSSS",paramsFile)
    return ApiGet.actions.PengadaanFiles(paramsFile)
    .then(res => {
        if (responseResult(res)){
            // console.log("res",res)
            dispatch(setFileById(responseResult(res)))
        }
        dispatch(setDataLoading(false))
        })
        .catch(err => {
            dispatch(resetFileById())
            dispatch(setDataLoading(false))
        })

}